"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _toggleSwitch = require("./toggle-switch");
Object.keys(_toggleSwitch).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _toggleSwitch[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _toggleSwitch[key];
    }
  });
});